import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const r = (l) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(l),
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9993 5.2509C16.3436 5.18357 20.6983 8.184 23.3781 11.1304L23.3805 11.133C23.7797 11.5762 24.0006 12.1515 24.0006 12.748C24.0006 13.3445 23.7797 13.9198 23.3805 14.363L23.3783 14.3654C20.7596 17.2475 16.4155 20.3164 11.9993 20.2481C7.58296 20.3164 3.2399 17.2474 0.622992 14.3652L0.621 14.363C0.221809 13.9198 0.000905067 13.3445 0.000905067 12.748C0.000905067 12.1515 0.221813 11.5762 0.621005 11.133L0.623142 11.1307C3.30019 8.18398 7.6549 5.18357 11.9993 5.2509ZM1.73462 12.138C1.58415 12.3055 1.50091 12.5228 1.50091 12.748C1.50091 12.9733 1.58417 13.1905 1.73467 13.3581C4.24333 16.1206 8.20786 18.8117 11.9866 18.7481H12.0119C15.7907 18.8117 19.7562 16.1207 22.267 13.358C22.4174 13.1904 22.5006 12.9732 22.5006 12.748C22.5006 12.5228 22.4174 12.3056 22.267 12.1381C19.7014 9.31787 15.7247 6.68826 12.0119 6.75089H11.9866C8.27378 6.68826 4.29702 9.31803 1.73462 12.138Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1478 9.97721C12.7837 9.82644 12.3935 9.7489 11.9995 9.749C11.4062 9.749 10.826 9.92493 10.3326 10.2545C9.83931 10.5841 9.45479 11.0526 9.22771 11.6008C9.00062 12.1489 8.94116 12.7521 9.05685 13.334C9.17254 13.9159 9.45819 14.4504 9.87766 14.87C10.2971 15.2896 10.8316 15.5754 11.4135 15.6913C11.9954 15.8071 12.5986 15.7478 13.1468 15.5209C13.695 15.2939 14.1635 14.9095 14.4933 14.4163C14.823 13.9231 14.9991 13.3431 14.9993 12.7498C14.9995 12.3558 14.922 11.9653 14.7714 11.6013C14.6207 11.2372 14.3998 10.9063 14.1212 10.6277C13.8426 10.349 13.5118 10.128 13.1478 9.97721ZM11.9993 8.249C12.5903 8.24887 13.1756 8.3652 13.7217 8.59135C14.2678 8.81753 14.764 9.14911 15.182 9.56715C15.5999 9.98519 15.9313 10.4815 16.1574 11.0277C16.3834 11.5738 16.4996 12.1592 16.4993 12.7502M11.9993 8.249C11.1094 8.24904 10.2393 8.51293 9.49933 9.0073C8.75933 9.50172 8.18255 10.2045 7.84192 11.0266C7.50129 11.8488 7.41211 12.7536 7.58565 13.6265C7.75918 14.4993 8.18765 15.3012 8.81686 15.9306C9.44608 16.5599 10.2478 16.9886 11.1206 17.1624C11.9935 17.3362 12.8982 17.2472 13.7205 16.9068C14.5428 16.5664 15.2457 15.9898 15.7403 15.2499C16.2349 14.5101 16.499 13.6401 16.4993 12.7502",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.0702 2.4806C22.3571 2.77941 22.3474 3.25419 22.0486 3.54104L3.29858 21.541C2.99977 21.8279 2.525 21.8182 2.23814 21.5194C1.95128 21.2206 1.96097 20.7458 2.25978 20.459L21.0098 2.45896C21.3086 2.1721 21.7834 2.18179 22.0702 2.4806Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.1428 8.43863C19.3866 8.10374 19.8557 8.02986 20.1906 8.27363C21.3478 9.11596 22.415 10.0754 23.3753 11.1368C23.7762 11.5784 23.9984 12.1535 23.9984 12.75C23.9984 13.3468 23.776 13.9221 23.3747 14.3638C20.7599 17.2542 16.412 20.3216 11.9946 20.25C10.9032 20.2544 9.81758 20.0911 8.77571 19.7659C8.38031 19.6425 8.15983 19.2219 8.28325 18.8265C8.40666 18.4311 8.82725 18.2106 9.22265 18.3341C10.1201 18.6142 11.0554 18.7545 11.9956 18.75L12.012 18.7499C15.7914 18.8145 19.7593 16.1246 22.263 13.3569L22.2643 13.3555C22.4149 13.1898 22.4984 12.9739 22.4984 12.75C22.4984 12.5261 22.4149 12.3102 22.2643 12.1445L22.263 12.1432C21.3719 11.1583 20.3816 10.268 19.3078 9.48638C18.9729 9.24262 18.899 8.77352 19.1428 8.43863Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0097 5.25007C13.8991 5.27026 15.7573 5.73411 17.4346 6.60426C17.8022 6.79501 17.9457 7.2477 17.7549 7.61538C17.5642 7.98306 17.1115 8.12649 16.7438 7.93574C15.2745 7.17347 13.6465 6.76728 11.9913 6.74996L11.9866 6.75089C10.1621 6.71896 8.24418 7.34713 6.43975 8.36347C4.63962 9.3774 2.9966 10.7519 1.73483 12.1437C1.5842 12.3094 1.5 12.5261 1.5 12.75C1.5 12.9739 1.58347 13.1898 1.7341 13.3555L1.73819 13.36C3.10483 14.8877 4.70669 16.1875 6.4833 17.21C6.8423 17.4166 6.96583 17.8751 6.75921 18.2341C6.55259 18.5931 6.09407 18.7167 5.73506 18.51C3.82084 17.4083 2.09372 16.0089 0.621 14.363C0.220702 13.9215 0 13.346 0 12.75C0 12.1531 0.222442 11.5776 0.623896 11.1359C1.98208 9.6378 3.74892 8.15751 5.70361 7.05653C7.6534 5.95832 9.8351 5.21265 12.0097 5.25007Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0362 10.38C13.4485 9.91886 12.7141 9.6854 11.968 9.72259C11.222 9.75979 10.5144 10.0651 9.97553 10.5824C9.43665 11.0998 9.1027 11.7943 9.0351 12.5382C8.9675 13.2821 9.17079 14.0255 9.6076 14.6314C9.8498 14.9675 9.77376 15.4362 9.43774 15.6784C9.10172 15.9206 8.63297 15.8446 8.39077 15.5086C7.74261 14.6094 7.44094 13.5064 7.54125 12.4025C7.64156 11.2986 8.13711 10.268 8.93673 9.50037C9.73635 8.73273 10.7863 8.27964 11.8933 8.22445C13.0004 8.16926 14.0902 8.51568 14.9622 9.19999C15.2881 9.4557 15.3449 9.92716 15.0892 10.253C14.8335 10.5789 14.362 10.6357 14.0362 10.38Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.7492 12C16.1634 12 16.4993 12.336 16.4993 12.7502C16.4993 13.3412 16.3828 13.9261 16.1566 14.4721C15.9305 15.018 15.599 15.5141 15.1812 15.932C14.7633 16.3498 14.2665 16.6807 13.7205 16.9068C13.1745 17.1329 12.5901 17.25 11.9992 17.25C11.585 17.25 11.2492 16.9142 11.2492 16.5C11.2492 16.0858 11.585 15.75 11.9992 15.75C12.3931 15.75 12.7828 15.6716 13.1468 15.5209C13.5107 15.3701 13.8419 15.1499 14.1205 14.8713C14.3991 14.5927 14.6201 14.262 14.7708 13.8981C14.9216 13.5341 14.9993 13.1438 14.9993 12.7498C14.9993 12.3356 15.335 12 15.7492 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  r as EyeOffIcon
};
//# sourceMappingURL=EyeOffIcon.js.map
